// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-item {
  padding: 12px 20px;
  border-bottom: 1px solid #333;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;
}

.notification-item:hover {
  background-color: #2a2a2a;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background-color: rgba(0, 255, 0, 0.05);
  border-left: 3px solid #00ff00;
}

.notification-item.unread:hover {
  background-color: rgba(0, 255, 0, 0.1);
}

.notification-item-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
}

.notification-icon {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  font-weight: bold;
  color: #00ff00;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 255, 0, 0.1);
  border-radius: 50%;
}

.notification-text {
  flex: 1 1;
  min-width: 0;
}

.notification-message {
  margin: 0 0 4px 0;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

.notification-time {
  color: #888;
  font-size: 12px;
  font-weight: 400;
}

.notification-unread-indicator {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #00ff00;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(0, 255, 0, 0.5);
}

/* Responsive design */
@media (max-width: 768px) {
  .notification-item {
    padding: 10px 16px;
  }
  
  .notification-message {
    font-size: 13px;
  }
  
  .notification-time {
    font-size: 11px;
  }
  
  .notification-icon {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .notification-item {
    padding: 8px 12px;
  }
  
  .notification-message {
    font-size: 12px;
  }
  
  .notification-time {
    font-size: 10px;
  }
  
  .notification-icon {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/notifications/NotificationItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".notification-item {\n  padding: 12px 20px;\n  border-bottom: 1px solid #333;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  position: relative;\n}\n\n.notification-item:hover {\n  background-color: #2a2a2a;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item.unread {\n  background-color: rgba(0, 255, 0, 0.05);\n  border-left: 3px solid #00ff00;\n}\n\n.notification-item.unread:hover {\n  background-color: rgba(0, 255, 0, 0.1);\n}\n\n.notification-item-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  position: relative;\n}\n\n.notification-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n  margin-top: 2px;\n  font-weight: bold;\n  color: #00ff00;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 255, 0, 0.1);\n  border-radius: 50%;\n}\n\n.notification-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-message {\n  margin: 0 0 4px 0;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n.notification-time {\n  color: #888;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.notification-unread-indicator {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  background-color: #00ff00;\n  border-radius: 50%;\n  box-shadow: 0 0 6px rgba(0, 255, 0, 0.5);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .notification-item {\n    padding: 10px 16px;\n  }\n  \n  .notification-message {\n    font-size: 13px;\n  }\n  \n  .notification-time {\n    font-size: 11px;\n  }\n  \n  .notification-icon {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .notification-item {\n    padding: 8px 12px;\n  }\n  \n  .notification-message {\n    font-size: 12px;\n  }\n  \n  .notification-time {\n    font-size: 10px;\n  }\n  \n  .notification-icon {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
